import React, {useState} from 'react'
import {Button, ButtonGroup, Card, Col, Form, Row} from 'react-bootstrap'
import './custom.css'

export default function DinamicFilter({ fields, actions, filterFn, afterClearFilterFn }) {
  const [filters, setFilters] = useState([getFilterModel()])

  const joinList = [
    { label: 'E', value: 'AND' },
    { label: 'OU', value: 'OR' },
  ]

  const comparisonList = [
    { label: 'Igual', value: 'EQUAL' },
    { label: 'Maior', value: 'GT' },
    { label: 'Maior Igual', value: 'GTE' },
    { label: 'Menor', value: 'LT' },
    { label: 'Menor Igual', value: 'LTE' },
    { label: 'Contido em', value: 'LIKE' },
    { label: 'Inicia com', value: 'START_WITH' },
    { label: 'Termina com', value: 'END_WITH' },
  ]

  function getFilterModel() {
    return { fieldKey: '', comparison: '', value: null, join: 'AND' }
  }

  function onChange(index, key, value) {
    setFilters(filters.map((f, i) => {
      if (i !== index) return f
      if (key === 'fieldKey') return { ...getFilterModel(), [key]: value }
      return { ...f, [key]: value }
    }))
  }

  function addFilter() {
    setFilters([...filters, getFilterModel()])
  }

  function removeFilter(index) {
    if (filters.length > 1) {
      setFilters(filters.filter((_, i) => i !== index))
    }
  }

  function clearFilter() {
    setFilters([getFilterModel()])
    if (afterClearFilterFn) afterClearFilterFn()
  }

  function filter() {
    const p = filters
      .filter(v => (v.value || v.value === false) && v.comparison && v.fieldKey)
      .map(f => {
        const type = fields.find(e => e.key === f.fieldKey)?.type || 'text'
        if (type === 'number') {
          return { ...f, value: parseFloat((f.value + '').replace('.', '').replace(',', '.')) }
        }
        if (type === 'date' && f.value instanceof Date) {
          return { ...f, value: f.value.toISOString().substring(0, 10) }
        }
        return f
      })
    if (p.length > 0) filterFn(p)
  }

  function getComparisonOptions(type) {
    return comparisonList.filter(el => {
      if (type === 'number' && ['END_WITH', 'START_WITH', 'LIKE'].includes(el.value)) return false
      if (type === 'date' && ['EQUAL', 'END_WITH', 'START_WITH', 'LIKE'].includes(el.value)) return false
      if (type === 'boolean' && el.value !== 'EQUAL') return false
      if (type === 'text' && !['EQUAL', 'END_WITH', 'START_WITH', 'LIKE'].includes(el.value)) return false
      return true
    })
  }

  return (
    <Card className="box-card dinamic-filter mx-3 my-3">
      <Card.Body>
        <small style={{ fontSize: '14px', color: '#48576a', lineHeight: 1 }}>Filtros</small>

        {filters.map((f, index) => {
          const type = fields.find(e => e.key === f.fieldKey)?.type || 'text'
          const isLast = index === filters.length - 1

          return (
            <div key={index} className="dinamic-filter-form mt-2">
              {index > 0 && (
                <Form.Group style={{ width: '110px' }}>
                  <Form.Control
                    as="select"
                    size="sm"
                    value={f.join}
                    onChange={e => onChange(index, 'join', e.target.value)}
                  >
                    {joinList.map(el => (
                      <option key={el.value} value={el.value}>{el.label}</option>
                    ))}
                  </Form.Control>
                </Form.Group>
              )}

              <Row>
                {/* Campo */}
                <Col xs={12} sm={12} md={3} className="mb-2">
                  <Form.Control
                    as="select"
                    size="sm"
                    value={f.fieldKey}
                    onChange={e => onChange(index, 'fieldKey', e.target.value)}
                  >
                    <option value="">Campo</option>
                    {fields.map(el => (
                      <option key={el.key} value={el.key}>{el.label}</option>
                    ))}
                  </Form.Control>
                </Col>

                {/* Comparação */}
                <Col xs={12} sm={12} md={3} className="mb-2">
                  <Form.Control
                    as="select"
                    size="sm"
                    value={f.comparison}
                    onChange={e => onChange(index, 'comparison', e.target.value)}
                  >
                    <option value="">Comparação</option>
                    {getComparisonOptions(type).map(el => (
                      <option key={el.value} value={el.value}>{el.label}</option>
                    ))}
                  </Form.Control>
                </Col>

                {/* Valor */}
                <Col xs={12} sm={12} md={3} className="mb-2">
                  {type === 'date' ? (
                    <Form.Control
                      size="sm"
                      type="date"
                      value={f.value ? (f.value instanceof Date ? f.value.toISOString().substring(0, 10) : f.value) : ''}
                      onChange={e => onChange(index, 'value', e.target.value ? new Date(e.target.value + 'T00:00:00') : null)}
                    />
                  ) : type === 'boolean' ? (
                    <Form.Control
                      as="select"
                      size="sm"
                      value={f.value === null || f.value === undefined ? '' : String(f.value)}
                      onChange={e => {
                        const val = e.target.value === '' ? null : e.target.value === 'true'
                        onChange(index, 'value', val)
                      }}
                    >
                      <option value="">Valor</option>
                      <option value="true">Sim</option>
                      <option value="false">Não</option>
                    </Form.Control>
                  ) : (
                    <Form.Control
                      size="sm"
                      placeholder="Valor"
                      value={f.value || ''}
                      onChange={e => onChange(index, 'value', e.target.value)}
                    />
                  )}
                </Col>

                {/* Ações */}
                <Col xs={12} sm={12} md={3} className="mb-2 d-flex align-items-start flex-wrap gap-1">
                  <ButtonGroup className="mr-1">
                    <Button variant="primary" onClick={addFilter} title="Adicionar filtro">+</Button>
                    <Button variant="danger" onClick={() => removeFilter(index)} title="Remover filtro">🗑</Button>
                  </ButtonGroup>

                  {isLast && (
                    <>
                      <Button variant="info" className="mr-1" onClick={filter}>Filtrar</Button>
                      <Button variant="secondary" className="mr-1" onClick={clearFilter}>Limpar</Button>
                      {actions}
                    </>
                  )}
                </Col>
              </Row>
            </div>
          )
        })}
      </Card.Body>
    </Card>
  )
}
